/**
 * Recording indicator with elapsed time. soft for panels, solid for the mobile camera, menubar for the OS menu bar.
 */
export interface RecPillProps {
  time?: string;
  /** Text instead of time, e.g. "Recording this tab" */
  label?: string;
  variant?: "soft" | "solid" | "menubar";
  className?: string;
}

export function RecPill({ time, label, variant = "soft", className }: RecPillProps): JSX.Element {
  const cls = [
    "gk-recpill",
    variant !== "soft" && "gk-recpill--" + variant,
    label && !time && "gk-recpill--label",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={cls} role="status">
      <span className="gk-recpill__dot" />
      {time ? (variant === "soft" ? "REC " + time : time) : label}
    </span>
  );
}
